"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorText = function (_a) {
    var errors = _a.errors, displayedText = _a.displayedText;
    if (Object.keys(errors).length === 0 || !errorsToBeDisplayed(errors)) {
        return React.createElement("div", { className: 'has-errors-message-empty' });
    }
    var defaultDisplayedText = 'You have some invalid entries, please review';
    return (React.createElement("div", { className: 'has-errors-message' }, displayedText ? displayedText : defaultDisplayedText));
};
var errorsToBeDisplayed = function (errors) {
    if (errors === void 0) { errors = {}; }
    for (var name_1 in errors) {
        if (errors[name_1] !== true) {
            return true;
        }
    }
    return false;
};
exports.default = ErrorText;
